/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import store from "../../store";
import EmployerAnalytics from "./EmployerInsights";

export interface IProviderProps {
  hubAdminPresent: boolean;
  isPortalUser: boolean;
  parentChildEnabled: boolean;
}

const ProviderComponent: FunctionComponent<IProviderProps> = ({
  hubAdminPresent,
  isPortalUser,
  parentChildEnabled,
}) => (
  <Provider store={store}>
    <EmployerAnalytics
      hubAdminPresent={hubAdminPresent}
      isPortalUser={isPortalUser}
      parentChildEnabled={parentChildEnabled}
    />
  </Provider>
);

ProviderComponent.propTypes = {
  hubAdminPresent: PropTypes.bool.isRequired,
  isPortalUser: PropTypes.bool.isRequired,
  parentChildEnabled: PropTypes.bool.isRequired,
};

export default ProviderComponent;
